import { render, staticRenderFns } from "./insights-index.vue?vue&type=template&id=72fc9d2f&scoped=true"
import script from "./insights-index.vue?vue&type=script&lang=js"
export * from "./insights-index.vue?vue&type=script&lang=js"
import style0 from "./insights-index.vue?vue&type=style&index=0&id=72fc9d2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc9d2f",
  null
  
)

export default component.exports